import { useRouter } from "next/router";
import Modal from "../ui/modal";
import SearchPrompt from "../ui/search-prompt";
import SearchMenuItems from "../ui/search-menu-items";
import SearchModalInput from "../ui/search-modal-input";
import { useTranslations } from "next-intl";

const SearchModal = ({toggleModal, isOpen, children, onAskAi, onSearchChange}) => {
  const router = useRouter();
  const t = useTranslations('generalSearch');

  function handleSearch(e) {
    e.preventDefault();
    onSearchChange(e);
  }

  function handleCloseModal() {
    router.push("/");
  }

  if (!isOpen) {
    return null;
  }

  return (
    <>
      <Modal toggleModal={toggleModal} isOpen={isOpen} ignoreX additionalclasses='!pb-[23px] !px-0 !w-[837px] !bg-white-50 dark:!bg-white-dark-50' childrenClass='!px-0'>
          <SearchModalInput placeholder={t('searchPlaceholder')} onAskAi={onAskAi} onChange={onSearchChange}/>
          <div className="h-[1px] custom-bg-grey-50 mb-[12px]"/>
          {children}
      </Modal>
    </>
  );
};

export default SearchModal;
